export default {
  title: 'Strategy',
  sections: {
    strategy_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">Our strategy</div> Maximum performance as EQUAL PARTNERS',
            text2: 'The SEU Group brings together the best in the industry',
            image: '/seu/latest-assets/seu_26.jpg',
          }
        },
      }
    },
    strategy_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Strategy'
          }
        }
      }
    },
    strategy_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_33.jpg',
          }
        }
      }

    },
    strategy_text_section: {
      fields: {
        field_one: {
          value: {
            text: 'Take advantage of personal opportunities – grow as a group'
          }
        },
        field_two: {
          value: {
            text: `Through integration with the SEU Group, we’ll jointly assume responsibility for your company in the future. Our vision: achieving peak performance together.`
          }
        },
        field_three: {
          value: {
            text: 'SEU is the platform for engineers in Switzerland. Our group grows through the acquisition and smooth integration of thriving SMEs. The former owners of the partner companies become a part of SEU.',
            text2: 'We’re professionals in construction, geomatics and planning in German-speaking Switzerland with international production facilities. That enables us to take charge of complex projects, meet peak workloads with professional composure and continue developing our core business.',
            text3: 'We build on a foundation of innovation, expertise and entrepreneurship. Our one goal: to actively shape the future of our industry. Together with you.'
          }
        },
      }
    },
    strategy_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Strategy'
          }
        }
      }
    },
    strategy_text_2_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">Our business strategy</div> <br/> By engineers, for engineers'
          }
        },
        field_two: {
          value: {
            text: '<p>By engineers, for engineers – that’s SEU’s answer to the challenges currently facing the engineering industry. We’re nationally oriented, build on regionally established SMEs and operate international production facilities.</p> <p> As a group, we combine the strengths of our partner companies and continue the targeted development of their competitive advantages. We’re driven by innovation. It’s in our genes.</p>',
          }
        },
      }
    },
    strategy_divider3_section: {
      fields: {
        field_one: {
          value: {
            divider: 'The SEU growth strategy: acquire, network, develop'
          }
        }
      }
    },
    strategy_features_section: {
      fields: {
        field_one: {
          value: {
            boxes: [
              {
                title: 'Acquisition',
                image: '/seu/latest-icons/growth.svg',
                subTitle: `We seek growth proactively through targeted acquisitions. We value the carefully selected acquisition of successful and locally rooted engineering firms. Challenges that leave smaller companies swaying on stormy seas are easier to manage in a network of experts.`
              },
              {
                title: 'Regional excellence',
                image: '/seu/latest-icons/location.svg',
                subTitle: `Our goal is to build an outstanding national presence with international reputation and appeal. To achieve this, SEU brings together capable centers of regional expertise that serve as pillars of our success story. This structure gives us the greatest possible flexibility and exceptional impact – both on a regional and national level and in bordering countries.`,
                buttonLabel: 'more',
                buttonLabelLess: 'less'
              },
              {
                title: 'Multibrand strategy',
                image: '/seu/latest-icons/market-strategy.svg',
                subTitle: `We embody a high-performance, multi-brand strategy. This makes it possible for each partner company to further develop its brand and independence, while at the same time benefiting from the advantages and synergy effects within the group:
<ul> <li>Cross-selling </li>
 <li> Economies of scale</li>
 <li> High-margin performance</li>
 <li> Offshore production facilities</li>
 <li> New markets and fields of activity</li>
 <li> Growing project capacity</li>
 <li> Combined expert knowledge </li> </ul>`,
                buttonLabel: 'more',
                buttonLabelLess: 'less'
              },
              {
                title: 'Digitalization',
                image: '/seu/latest-icons/digitization.svg',
                subTitle: `Through digital innovation and artificial intelligence, we as a group are creating crucial synergies and optimizing resources to continuously improve the operational and administrative processes of our partner companies.`,
              },
              {
                title: 'Customer loyalty  ',
                image: '/seu/latest-icons/customer-loyalty.svg',
                subTitle: `We’re continually expanding our portfolio. Our characteristic features are working closely with clients, being focused on their needs and providing services of the highest quality. We work together with and for:
<ul> <li> Swiss architects </li>
<li> Private builders facing complex challenges</li>
<li> Companies and organizations with one or more locations in Switzerland or neighboring countries</li>
<li> Public authorities (at the federal, cantons and municipal level)</li>`,
                buttonLabel: 'more',
                buttonLabelLess: 'less'
              },

            ]
          }
        }
      }
    },
    strategy_divider4_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Focus on employees'
          }
        }
      }
    },
    strategy_features_2_section: {
      fields: {
        field_one: {
          value: {
            boxes: [
              {
                title: 'Developing people',
                image: '/seu/latest-icons/stairs.svg',
                subTitle: `We embody participation and promote continued training in the SEU Academy and through the SEU employee participation program. This helps create optimal conditions for the targeted development and utilization of employees’ individual strengths and potential.`,
              },
              {
                title: 'Transparency',
                image: '/seu/latest-icons/magnifying-glass.svg',
                subTitle: `We actively involve partner companies in the integration process and support them with a clearly structured on-boarding plan. Expectations and goals as well as all the steps that go into integration are transparent for all sides from the beginning.`
              },
              {
                title: 'Trust',
                image: '/seu/latest-icons/hand-heart.svg',
                subTitle: `For us, trustworthy and reliable communication is a matter of course. Personal support throughout the process and feedback rounds ensure that we’re aware of all needs and can take them into account.`
              },
              {
                title: 'Purpose',
                image: '/seu/latest-icons/hand-heart-2.svg',
                subTitle: `Motivation comes from the personal significance of each action, appreciation for accomplishment and time and space for personal and professional development. All this is important to us – because it helps employees to thrive and perform at their best.`
              },
            ]
          }
        }
      }
    },
    strategy_divider5_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Smooth integration'
          }
        }
      }
    },
    strategy_text_3_section: {
      fields: {
        field_one: {
          value: {
            text: 'SEU’s strategy for smooth integration is characterized by a carefully planned approach. We make sure that only the most necessary changes are made when integrating new partner companies. We especially value the preservation of the individual brand image, the external market profile and the unique spirit of the corporate culture.'
          }
        },
        field_two: {
          value: {
            text: 'Instead, the focus is on high efficiency, healthy growth and long-term synergy effects – in both operations and in critical areas:',
            boxes: [
              {
                name: 'Administration and digitalization'
              },
              {
                name: 'Marketing and sales'
              },
              {
                name: 'Recruitment of qualified specialists'
              },
              {
                name: 'Personnel development'
              },
              {
                name: 'Optimal utilization'
              },
              {
                name: 'Development and innovation'
              },
              {
                name: 'Succession management'
              },
            ],
            text2: 'With this targeted approach, we achieve the successful integration of new partner companies without impacting the individual character of each company. ',
          }
        },
      }
    },
    strategy_divider6_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Co-entrepreneurship'
          }
        }
      }
    },
    strategy_text_4_section: {
      fields: {
        field_one: {
          value: {
            text: 'Owners who sell their companies to SEU and take an active role in its integration are welcomed to the group as co-entrepreneurs. Employees in key positions can also contribute to the success story and become co-entrepreneurs. As key contributors, they’re an important part of the shareholder base and thus an important piece for solving the success puzzle. They help guide SEU’s development and share in the profits.'
          }
        },
        field_two: {
          value: {
            text: 'Your benefits as a co-entrepreneur:',
            boxes: [
              {
                name: 'Your expertise will be part of a strong network of entrepreneurs with a national reputation.'
              },
              {
                name: 'You will be part of shaping the future of the SEU Group and will share in its success.'
              },
              {
                name: 'You can be assured of a solution for ownership succession.'
              },
              {
                name: 'You can offer your employees shareholding in the SEU Group.'
              },
            ]
          }
        },
      }
    },
    strategy_divider7_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Managementsupport'
          }
        }
      }
    },
    strategy_text_5_section: {
      fields: {
        field_one: {
          value: {
            text: 'We value our partner companies’ history of success and support their management team on the way towards our shared future.'
          }
        },
        field_two: {
          value: {
            text: 'Your benefits as a partner company:',
            boxes: [
              {
                name: 'Your brand will live on.'
              },
              {
                name: 'Your company will retain operational freedom and independence.'
              },
              {
                name: 'Your existing client relationships will be maintained, while you can intelligently expand your portfolio at the same time.'
              },
              {
                name: 'Your employees can rely on the accustomed corporate culture.'
              },
              {
                name: 'Your company will benefit from synergy effects and remain competitive for the long term.'
              },
            ]
          }
        },
      }
    },
    strategy_call_to_action_section: {
      fields: {
        field_one: {
          value: {
            text: 'What is your biggest challenge?',
            buttonLabel: 'Let’s tackle it together',
            buttonLink: '/en/services',
            image: '/seu/latest-assets/seu_19.jpg',
          }
        },
      }
    },
    strategy_divider8_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Strategy'
          }
        }
      }
    },
    strategy_text_6_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">Success stories</div>  of our partner companies'
          }
        },
        field_two: {
          value: {
            text: 'Our partnerships are the heart of Swiss Engineers United'
          }
        },
        field_three: {
          value: {
            text: 'The first SEU company is the <a href="https://hmq.ch/" target="_blank" class="text-highlight">HMQ-Gruppe</a>, headquartered in Graubünden and with additional locations in Aargau and Zurich.'
          }
        },
        field_four: {
          value: {
            text: 'The HMQ Group focuses on innovation, quality and technology. It consists of HMQ AG, HMQ Gebäude AG, HMQ Geomatik AG and HMQ Projekt AG. It’s known for its diversified engineering portfolio and internationally oriented services. HMQ has been established in the engineering industry for more than 30 years and has been active throughout German-speaking Switzerland and neighboring countries for many years.',
            text2: 'Key facts:',
            boxes: [
              {
                name: 'Founded in 1974'
              },
              {
                name: 'Integrated into SEU in 2022'
              },
              {
                name: 'Around 50 employees in Switzerland'
              },
              {
                name: 'Production facilities in Hungary and Indonesia with around 85 employees'
              },
              {
                name: 'A pioneer and market leader in BIM-capable 3D building data'
              },
              {
                name: 'Innovative and efficient technologies for preservation of evidence and other processes'
              },
              {
                name: 'High level of digitalization and effective digital marketing'
              },
              {
                name: 'Experienced in attracting highly qualified specialists'
              },

            ]
          },

        },
      }
    },
    strategy_divider9_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Results'
          }
        }
      }
    },
    strategy_call_to_action_2_section: {
      fields: {
        field_one: {
          value: {
            testimonials: [
              {
                text: '“For 30 years, I’ve been working for HMQ AG as a geomatics expert. Integration into the SEU holding company has preserved the HMQ spirit. The opportunity to open up new fields of activity and areas of application encourages me to continue working here.“',
                text2: 'Christian Schmid',
                image: '/seu/testimonial1.jpg'
              },
              {
                text: 'As a member of the HMQ Group’s management team and managing director of HMQ Gebäude AG, I’ve worked to advance integration with SEU. Their business model is convincing in every respect.',
                text2: 'Daniel Gantenbein',
                image: '/seu/testimonial1.jpg'
              }
            ]

          }
        },
      }
    },
  }
}
